import {
  CountryDTO,
  MbeServiceDTO,
  ShipType,
  SubcountryDTO
} from "@/model/data.model";
import * as moment from "moment";
import { OnlineMbePackTypeDef } from "@/model/component.model";

export class ShipmentCalculateCostClass {
  addressFrom: IShipmentCalculateCostAddress;
  addressTo: IShipmentCalculateCostAddress;
  packTypes: OnlineMbePackTypeDef[];
  packType: any;
  totalWeight: number;
  shipmentPackages: IShipmentCalculateCostPackage[];
  shipmentType: ShipType;
  mbeServices: MbeServiceWithShipmentTypeDTO[] = [];
  mbeService: MbeServiceWithShipmentTypeDTO = {} as MbeServiceWithShipmentTypeDTO;
  extraServices: any[];
  pickupDate: Date;
  mbeCurrencySymbol: string;
  storeCountryId: string;

  constructor(data: { mbeCurrencySymbol: string; storeCountryId: string }) {
    this.addressFrom = {
      directionAddress: "addressFrom",
      country: {
        id: "",
        name: ""
      },
      subcountries: [],
      subcountry: null,
      zipCode: "",
      city: ""
    };
    this.addressTo = {
      directionAddress: "addressTo",
      country: {
        id: "",
        name: ""
      },
      subcountries: [],
      subcountry: null,
      zipCode: "",
      city: ""
    };
    this.packTypes = [];
    this.packType = {
      idMBEBusiness: null,
      idMBEPackType: null,
      packTypeDescription: "",
      tenantId: null,
      translatedPackTypeDescription: ""
    };
    this.shipmentPackages = [
      {
        sequence: 0,
        width: 0,
        height: 0,
        depth: 0,
        customerWeight: 1
      }
    ];
    this.shipmentType = "DOMESTIC";
    this.mbeServices = [];
    this.mbeService = {} as MbeServiceWithShipmentTypeDTO;
    this.pickupDate = new Date();
    this.extraServices = [];
    this.totalWeight = this.getTotalWeight;
    this.mbeCurrencySymbol = data.mbeCurrencySymbol;
    this.storeCountryId = data.storeCountryId;
  }

  changeTotalShipmentWeight(value: number) {
    this.totalWeight = value;
    const shipmentWeight = this.totalWeight / this.shipmentPackages.length;
    this.shipmentPackages.forEach(
      item => (item.customerWeight = shipmentWeight)
    );
  }

  packageCountModified(value: number) {
    const packagesLen = this.shipmentPackages.length;
    if (value > packagesLen) {
      const diff = value - packagesLen;
      for (let i = 0; i < diff; i++) {
        this.shipmentPackages.push({
          sequence: this.shipmentPackages.length,
          width: 0,
          height: 0,
          depth: 0,
          customerWeight: 0
        });
      }
    } else if (value < packagesLen) {
      const diff = packagesLen - value;
      for (let i = 0; i < diff; i++) {
        this.shipmentPackages.pop();
      }
    }
  }

  fillAddresses(data) {
    Object.keys(data).forEach(key => {
      this[key].country.id = data[key].country.id;
      this[key].country.name = data[key].country.name;
      this[key].zipCode = data[key].zipCode;
      this[key].city = data[key].city;
      this[key].subcountry = data[key].subcountry ? data[key].subcountry : null;
      this[key].subcountries = data[key].subcountries
        ? data[key].subcountries
        : [];
    });
  }

  getPayload(customerMbeId, storeZipCode, storeCity): any {
    return {
      addressFrom: { countryId: this.addressFrom.country.id },
      addressTo: { countryId: this.addressTo.country.id },
      shipType: this.getShipmentType || "EXPORT",
      zipCodeFrom: this.addressFrom.zipCode,
      placeNameFrom: this.addressFrom.city || "",
      zipCodeTo: this.addressTo.zipCode,
      storeZipCode: storeZipCode,
      storeCity: storeCity,
      placeNameTo: this.addressTo.city || "",
      idMBECustomer: customerMbeId,
      idSubcountryFrom: this.addressFrom.subcountry.idSubcountry,
      idSubcountryTo: this.addressTo.subcountry.idSubcountry,
      idMBEService: this.mbeService.idMBEBusiness || null,
      idMBEPackType: this.packType.packtypeBusinessId,
      pickupDate: moment(this.pickupDate).format("DD/MM/YYYY"),
      skipRate: true,
      useOtherExtraServiceAndShipmentAndExtraServiceValueForBase: false,
      packageNumber: this.shipmentPackages.length,
      packages: this.shipmentPackages.map(item =>
        Object.assign({}, item, { courierWeight: item.customerWeight })
      ),
      inputSurcharges: this.extraServices
        .filter(item => item.active)
        .map(item => ({
          mbeBusinessId: item.idMBEBusiness,
          extraServiceValue: item.value,
          cost: true
        }))
    };
  }

  checkInputData(data) {
    const exceedExtra = this.extraServices.filter(
      item =>
        item.extraServiceMaxValue > 0 &&
        item.value &&
        item.value > item.extraServiceMaxValue
    );
    const isShipmentWeightExceed =
      data.maxShipmentWeight > 0 && this.totalWeight > data.maxShipmentWeight;
    const isPackageWeightExceed =
      data.maxPackageWeight > 0 &&
      this.shipmentPackages.some(
        item => item.customerWeight > data.maxPackageWeight
      );
    const exceedData = {};
    const extraNamesMap = {
      extra_max_for_safe_value: 1,
      extra_max_for_cod: 2,
      extra_max_for_insurance: 3
    };
    exceedExtra.forEach(item => {
      const key = Object.keys(extraNamesMap).find(
        key => extraNamesMap[key] === item.idMBEBusiness
      );
      exceedData[key] = [
        `${item.extraServiceMaxValue.toFixed(2)} ${this.mbeCurrencySymbol}`
      ];
    });
    if (isShipmentWeightExceed) {
      exceedData["max_shipment_weight_is"] = [data.maxShipmentWeight, "kg"];
    }
    if (isPackageWeightExceed) {
      exceedData["max_package_weight_is"] = [data.maxPackageWeight, "kg"];
    }
    return exceedData;
  }

  get getTotalWeight() {
    let sum = 0;
    this.shipmentPackages.forEach(item => {
      sum += item.customerWeight;
    });
    return sum;
  }

  get calculateBtnDisable() {
    if (this.addressFrom.subcountry && this.addressTo.subcountry) {
      return (
        !this.addressFrom.subcountry.idSubcountry ||
        !this.addressTo.subcountry.idSubcountry ||
        this.shipmentPackages.some(item => item.customerWeight === 0) ||
        !this.packType.onlineMbePackTypeId ||
        this.extraServices.some(item => item.active && item.value === 0)
      );
    } else {
      return true;
    }
  }

  get getShipmentType() {
    let shipmentTypesMap;
    if (this.addressFrom.subcountry && this.addressTo.subcountry) {
      shipmentTypesMap = {
        DOMESTIC:
          this.addressFrom.subcountry.macroareaName === "NATIONAL" &&
          this.addressTo.subcountry.macroareaName === "NATIONAL",
        EXPORT:
          this.addressFrom.subcountry.macroareaName === "NATIONAL" &&
          this.addressTo.subcountry.macroareaName !== "NATIONAL",
        IMPORT:
          this.addressFrom.subcountry.macroareaName !== "NATIONAL" &&
          this.addressTo.subcountry.macroareaName === "NATIONAL"
      };
    } else {
      shipmentTypesMap = {
        DOMESTIC:
          this.addressFrom.country.id === this.storeCountryId &&
          this.addressTo.country.id === this.storeCountryId,
        EXPORT: this.addressFrom.country.id === this.storeCountryId,
        IMPORT: this.addressTo.country.id === this.storeCountryId
      };
    }
    return Object.keys(shipmentTypesMap).find(
      item => shipmentTypesMap[item]
    ) as ShipType;
  }

  get availableMbeServices() {
    return this.mbeServices.filter(item =>
      Object.keys(item.shipmentType).find(
        key => item.shipmentType[key] && key === this.getShipmentType
      )
    );
  }
}

interface IShipmentCalculateCostAddress {
  directionAddress: string;
  country: CountryDTO;
  subcountries: SubcountryDTO[];
  subcountry: SubcountryDTO;
  zipCode: string;
  city: string;
  province?: string;
}

interface IShipmentCalculateCostPackage {
  sequence: number;
  width: number;
  height: number;
  depth: number;
  customerWeight: number;
}

interface MbeServiceWithShipmentTypeDTO extends MbeServiceDTO {
  shipmentType: {
    DOMESTIC: boolean;
    IMPORT: boolean;
    EXPORT: boolean;
  };
}
